import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../app";
import { useLocation } from "react-router-dom";
import axios from "axios";

import ProductTemplate from "../../components/ProductTemplate/productTemplate";

function Product() {
    
    const shop = useContext(Context) 
    const id = "NEX"
    const location = useLocation().pathname.split("/")[1]

    useEffect(()=>{
        // console.log("location", location, "product", shop.products.filter((product)=>product.id===location)[0])
        // console.log(shop.products.filter((product)=>product.id===id)[0]?.picture)
        shop.setStage(1)
        shop.ReactPixel.trackCustom("ShopView", {
            page: shop.products.filter((product)=>product.id===location)[0]?.name
        })
        if (shop.mpid) {
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"shopView",
                    properties:{
                        page: shop.products.filter((product)=>product.id===location)[0]?.name
                    },
                    id:shop.mpid
                }
            }).then((res)=>{
                // localStorage.setItem("mp_uid", res.data.uid)
            })
            .catch((e)=>console.log(e))
        }
    },[shop.mpid])

    useEffect(()=>{
        shop.setShowNav(true)
    },[])

    return(
        <ProductTemplate 
            id={shop.products.filter((product)=>product.id===location)[0]?.id}
            name={shop.products.filter((product)=>product.id===location)[0]?.name}
            short={shop.products.filter((product)=>product.id===location)[0]?.short}
            price={shop.products.filter((product)=>product.id===location)[0]?.price}
            discount={shop.products.filter((product)=>product.id===location)[0]?.discount}
            img={shop.products.filter((product)=>product.id===location)[0]?.picture}
            info={shop.products.filter((product)=>product.id===location)[0]?.info}
            color={shop.products.filter((product)=>product.id===location)[0]?.color}
            colors={shop.products.filter((product)=>product.id===location)[0]?.colors}
            variant={shop.products.filter((product)=>product.id===location)[0]?.variant}
            variants={shop.products.filter((product)=>product.id===location)[0]?.variants}
            features={shop.products.filter((product)=>product.id===location)[0]?.features}
            description={shop.products.filter((product)=>product.id===location)[0]?.description}
            body={shop.products.filter((product)=>product.id===location)[0]?.body}
            bodies={shop.products.filter((product)=>product.id===location)[0]?.bodies}
            reviews={shop.products.filter((product)=>product.id===location)[0]?.reviews}
        />
    )
}

export default Product

